// src/hooks/useVendors.js
import { useState, useEffect, useCallback } from "react";
import {
  collection, onSnapshot, addDoc, updateDoc, deleteDoc, doc, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

export function useVendors(orgId) {
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    if (!orgId) return;
    return onSnapshot(collection(db, "organizations", orgId, "vendors"), (snap) => {
      const all = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      all.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      setVendors(all);
    });
  }, [orgId]);

  const addVendor = useCallback(async (vendor) => {
    await addDoc(collection(db, "organizations", orgId, "vendors"), {
      ...vendor,
      createdAt: serverTimestamp(),
    });
  }, [orgId]);

  const updateVendor = useCallback(async (vendorId, vendor) => {
    await updateDoc(doc(db, "organizations", orgId, "vendors", vendorId), vendor);
  }, [orgId]);

  const deleteVendor = useCallback(async (vendorId) => {
    await deleteDoc(doc(db, "organizations", orgId, "vendors", vendorId));
  }, [orgId]);

  return { vendors, addVendor, updateVendor, deleteVendor };
}
